// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DynPropertyTypes } from '@shared/commons/properties/DynPropertyTypes';
// Description of editing
export class QuickTableEditingInfo {
    constructor(controlType) {
        this.wasChanged = false; // for table Combobox if was something changed turn to true.
        this.OnlyImageForButton = false; // Don't draw an image on the button, just images and WITHOUT text
        this.OnlyImage_IfTextNotEmpty_ForButton = false; // Don't draw an image on the button, just images IF text is not empty
        this.DrawCheckBoxAsRadioButton = false; // Display a checkbox as a radio button
        this.Values = null; // ComboBox values
        this.ValuesObject = null;
        this.Min = 0; // Numeric parameters
        this.Max = 10000000;
        this.Inc = 1;
        this.DecimalPlaces = 0;
        this.IntervalsListForNumeric = null;
        this.IsDrawControl = true;
        this.EditingCell = null;
        this.Table = null;
        this.AddAll = true; // +++yura - for UsersLookup, SymbolsLookup
        this.AddMAM = true; // +++yura - MAM for UsersLookup, SymbolsLookup
        this.AddPortfolio = true; // +++yura - flag for adding Portfolio
        this.AddForwards = true;
        this.AddOptions = true;
        this.AutoCompleteSource = null; // AutoComplete for text fields
        this.allowInstrumentsHistories = false; // +++denis - flag for adding custom instruments
        this.ImageCell = null; // Cell image
        this.hoverImageCell = null; // Cell hover image
        this.ImageForRemoveButtonCells = null; // Image for Remove Buttons
        this.GetDataHandler = null; // Custom method for fetching data
        this.IsEditable = true;
        this.TooltipKey = '';
        this.ControlType = controlType;
    }
    GetCellTooltipKey() {
        return EditableControlTypes.has(this.ControlType) ? 'property.ClickToModify' : '';
    }
}
const EditableControlTypes = new Set([
    DynPropertyTypes.INTEGER,
    DynPropertyTypes.DOUBLE,
    DynPropertyTypes.COMBOBOX,
    DynPropertyTypes.COMBOBOX_COMBOITEM_TIF
]);
